<app-stages [stages]="stages" currentStage="Dane wniosku">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete="off" [formGroup]='form' (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class='col-md-8'>
        <div class='form-group' *ngIf='"office" as controlName'>
          <label [for]='controlName'>
            Wniosek składany do *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Urząd'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class='row'>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"documentReceiptMethod" as controlName'>
          <label [for]='controlName'>
            Sposób odbioru *
          </label>
          <select
            (change)="form.documentReceiptMethodChange(form.getElement($event).value)"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            <option [value]='item?.id' *ngFor='let item of receiptMethods()'>
              {{ item.name }}
            </option>
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.documentReceiptMethod.value === '2d8f8c02-14f2-428f-beae-6faadbc75170') {
        <div class="col-12">
          <app-alert [closable]="false">
            Odbiór osobisty jest możliwy po uprzednim umówieniu się telefonicznym z pracownikiem merytorycznym, przy
            odbiorze należy okazać dokument tożsamości.
          </app-alert>
        </div>
      }
      @if (form.objectName) {
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"objectName" as controlName'>
            <label [for]='controlName'>
              Wskazanie obiektu (np. nazwa): *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu wskazanie obiektu'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.roadOccupationPurpose) {
        <div class="col-md-6">
          <div class='form-group' *ngIf='"roadOccupationPurpose" as controlName'>
            <label [for]='controlName'>
              Cel zajęcia *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item.id' *ngFor='let item of application()?.service?.roadOccupationPurposes'>
                {{ item?.name }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.ePuapAddress) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"ePuapAddress" as controlName'>
            <label [for]='controlName'>
              Adres skrzynki E-puap *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu adres skrzynki E-puap'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.eDeliveryAddress) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"eDeliveryAddress" as controlName'>
            <label [for]='controlName'>
              Adres skrzynki E-doręczeń *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu adres skrzynki E-doręczeń'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    @if (form.roadTrafficImpact) {
      <div class="row">
        <div class="col-12">
          <p id="roadTrafficImpactDesc" class="pb-3">
            * Czy zajęcie pasa wpłynie na ruch drogowy, ograniczy widoczność na drodze lub wprowadzi zmiany w
            istniejącej organizacji ruchu pojazdów/pieszych?
          </p>
          <div class="form-group" *ngIf='"roadTrafficImpact" as controlName'>
            <div class="custom-radio custom-inline">
              <input aria-labelledby="roadTrafficImpactDesc"
                     [name]="controlName"
                     [formControlName]='controlName'
                     type="radio"
                     [id]="controlName + 'Tak'"
                     value="Tak">
              <label [for]="controlName + 'Tak'">
                Tak
              </label>
            </div>
            <div class="custom-radio custom-inline">
              <input aria-labelledby="roadTrafficImpactDesc"
                     [name]="controlName"
                     [formControlName]='controlName'
                     value="Nie"
                     type="radio"
                     [id]="controlName + 'Nie'">
              <label [for]="controlName + 'Nie'">
                Nie
              </label>
            </div>
          </div>
        </div>
      </div>
    }
    <div class='row'>
      @if (form.deviceType) {
        <div class="col-md-4">
          <div class='form-group' *ngIf='"deviceType" as controlName'>
            <label [for]='controlName'>
              Rodzaj urządzenia *
            </label>
            <select
              (change)="form.deviceTypeChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item' *ngFor='let item of form.deviceTypes'>
                {{ item }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.deviceName) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"deviceName" as controlName'>
            <label [for]='controlName'>
              Nazwa *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę urządzenia'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.applicationSubject) {
        <div class='col-md-4' *ngIf='applicationSubjectControlType === "text"'>
          <div class='form-group' *ngIf='"applicationSubject" as controlName'>
            <label [for]='controlName'>
              {{ application() | applicationSubjectLabel }} *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              [placeholder]='application() | applicationSubjectPlaceholder'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (showVehicleCategoriesInfo) {
          <div class="col-12">
            <app-alert [withoutIcon]="true" [closable]="false">
              <div class="editor-content">
                <p>
                  Kategoria I dotyczy pojazdów nienormatywnych:
                </p>
                <ul class="ms-3">
                  <li>
                    O długości, wysokości, naciskach osi
                  </li>
                  <li>
                    Rzeczywistej masie całkowitej nie większych od dopuszczalnych oraz o szerokości nieprzekraczającej
                    3,5 m
                  </li>
                </ul>
                <p>
                  Kategoria II dotyczy pojazdów nienormatywnych o:
                </p>
                <ul class="ms-3 mb-0">
                  <li>
                    naciskach osi i rzeczywistej masie całkowitej nie większych od dopuszczalnych
                  </li>
                  <li>
                    szerokości nieprzekraczającej 3,2 m
                  </li>
                  <li>
                    <p class="mb-1">długości nieprzekraczającej:</p>
                    <ol style="list-style: circle" class="ms-1 mb-1">
                      <li>
                        15 m dla pojedynczego pojazdu
                      </li>
                      <li>
                        23 m dla zespołu pojazdów
                      </li>
                    </ol>
                  </li>
                  <li>
                    wysokości nieprzekraczającej 4,3 m
                  </li>
                </ul>
              </div>
            </app-alert>
          </div>
        }
        <div class='col-md-4' *ngIf='applicationSubjectControlType === "select"'>
          <div class='form-group' *ngIf='"applicationSubject" as controlName'>
            <label [for]='controlName'>
              Wniosek dotyczy *
            </label>
            <select
              (change)="form.applicationSubjectChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of applicationSubjectOptions; track $index) {
                <option [value]='item'>{{ item }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.agreementNumber && form.agreementDate) {
        <div class="col-12"></div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"agreementNumber" as controlName'>
            <label [for]='controlName'>
              Nr decyzji/uzgodnienia @if (form.agreementNumber.hasValidator(form.Validators.required)) {
              *
            }
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nr decyzji/uzgodnienia'
              type='text'>
            <app-validation-errors [control]='form.agreementNumber'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"agreementDate" as controlName'>
            <label [for]='controlName'>
              Data decyzji/uzgodnienia @if (form.agreementDate.hasValidator(form.Validators.required)) {
              *
            }
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.exitClass) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"exitClass" as controlName'>
            <label [for]='controlName'>
              Klasa zjazdu *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of form.exitClasses; track $index) {
                <option [value]='item'>{{ item }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.applicationConcernsStreet) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"applicationConcernsStreet" as controlName'>
            <label [for]='controlName'>
              Wniosek dotyczy ulicy *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę ulicy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.transitPeriod) {
        <div class="col-md-4">
          <div class='form-group' *ngIf='"transitPeriod" as controlName'>
            <label [for]='controlName'>
              Okres przejazdu *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option value='6 miesięcy'>1 miesiąc</option>
              <option value='6 miesięcy'>6 miesięcy</option>
              <option value='12 miesięcy'>12 miesięcy</option>
              <option value='24 miesięcy'>24 miesięcy</option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    @if (form.legalInterest) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"legalInterest" as controlName'>
            <label [for]='controlName'>
              Interes prawny *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz interes'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.deviceTypeDescription) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"deviceTypeDescription" as controlName'>
            <label [for]='controlName'>
              Opis rodzaju urządzenia *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Opisz rodzaj urządzenia'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (!!form.comments) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"comments" as controlName'>
            <label [for]='controlName'>
              Uzasadnienie umieszczenia *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu uzasadnienie'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.showResponsiblePersonControls()) {
      <fieldset>
        <legend>Osoba odpowiedzialna</legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"responsiblePersonFirstName" as controlName'>
              <label [for]='controlName'>
                Imię *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu imię'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"responsiblePersonLastName" as controlName'>
              <label [for]='controlName'>
                Nazwisko *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwisko'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"responsiblePersonPhone" as controlName'>
              <label [for]='controlName'>
                Nr telefonu
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu numer telefonu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"responsiblePersonEmail" as controlName'>
              <label [for]='controlName'>
                E-mail
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu e-mail'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
    }
    @if (form.managerForm; as managerForm) {
      <app-manager-form [form]="managerForm">
      </app-manager-form>
    }
    @if (form.showCorrespondenceControls) {
      <fieldset>
        <legend>
          Dane osoby wyznaczonej przez wnioskodawcę do kontaktu
        </legend>
        <div class="row">
          @if (form.correspondenceFirstName) {
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"correspondenceFirstName" as controlName'>
                <label [for]='controlName'>
                  Imię/Imiona
                </label>
                <input
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu imię/imiona'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
          @if (form.correspondenceLastName) {
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"correspondenceLastName" as controlName'>
                <label [for]='controlName'>
                  Nazwisko
                </label>
                <input
                  [id]='controlName'
                  [formControlName]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  placeholder='Wpisz tu nazwisko'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
          @if (form.correspondencePhone) {
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"correspondencePhone" as controlName'>
                <label [for]='controlName'>
                  Numer telefonu
                </label>
                <input
                  mask='0*'
                  [id]='controlName'
                  [formControlName]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  placeholder='Wpisz tu numer telefonu'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
        </div>
      </fieldset>
    }
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
